import React from 'react'
import classnames from 'classnames'
import { withTranslation } from 'react-i18next'

import { getAssetsUrl } from 'helpers/getAssetsUrl'

const content = {
  recent: {
    imagePath: getAssetsUrl('users/55e75858-db3a-45ea-9923-7b56265ab90f.png'),
    description: 'feed',
  },
  leaderBoard: {
    imagePath: getAssetsUrl('users/5c25b99d-fedc-4616-ae81-e3bf05bd7b4e.png'),
    description: 'board',
  },
  stories: {
    imagePath: getAssetsUrl('users/55e75858-db3a-45ea-9923-7b56265ab90f.png'),
    description: 'stories',
  },
}

const FeedEmpty = ({ t, listType }) => (
  <div className={classnames({ 'feed-empty': true, 'feed-empty--leaderboard': listType === 'leaderBoard' })}>
    <img src={content[listType].imagePath} className="feed-empty__image" alt="No Items" />
    <div className="feed-empty__text">
      <div className="feed-empty__description">{t(content[listType].description)}</div>
    </div>
  </div>
)

FeedEmpty.displayName = 'FeedEmpty'

export default withTranslation('user')(FeedEmpty)
